import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanFinancialV1({ isReadOnly }: IProps) {
    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;
    return (

        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["dailyPaymentOrCashOutAvailable", "dailyPaymentOrCashOutAvailableMonth", "dailyPaymentOrCashOutAvailableYear", "dailyPaymentOrCashOutAvailableCapitalCost", "dailyPaymentOrCashOutAvailableAnnualCost", "dailyPaymentOrCashOutAvailableDailyPayment"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="dailyPaymentOrCashOutAvailable" label="Daily payment of &pound;2 or more to staff not to use the car (also known as cash-out)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'dailyPaymentOrCashOutAvailableMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'dailyPaymentOrCashOutAvailableYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="dailyPaymentOrCashOutAvailableCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="dailyPaymentOrCashOutAvailableAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                            <RenderTextField name="dailyPaymentOrCashOutAvailableDailyPayment" label="Daily payment value" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["seasonTicketOrCycleLoanAvailable", "seasonTicketOrCycleLoanAvailableMonth", "seasonTicketOrCycleLoanAvailableYear", "seasonTicketOrCycleLoanAvailableCapitalCost", "seasonTicketOrCycleLoanAvailableAnnualCost", "seasonTicketOrCycleLoanAvailableAnnualLoanAmount"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="seasonTicketOrCycleLoanAvailable" label="Site provides employees with season ticket/cycle loans" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'seasonTicketOrCycleLoanAvailableMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'seasonTicketOrCycleLoanAvailableYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="seasonTicketOrCycleLoanAvailableCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="seasonTicketOrCycleLoanAvailableAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                            <RenderTextField name="seasonTicketOrCycleLoanAvailableAnnualLoanAmount" label="Annual payment value" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["parkingPermitEligibilityRestrictions", "parkingPermitEligibilityRestrictionsMonth", "parkingPermitEligibilityRestrictionsYear", "parkingPermitEligibilityRestrictionsCapitalCost", "parkingPermitEligibilityRestrictionsAnnualCost", "parkingChargesForParticularGroupCharge"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="parkingPermitEligibilityRestrictions" label="Annual payment to give up entitlement to a parking permit" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'parkingPermitEligibilityRestrictionsMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'parkingPermitEligibilityRestrictionsYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="parkingPermitEligibilityRestrictionsCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingPermitEligibilityRestrictionsAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                            <RenderTextField name="parkingChargesForParticularGroupCharge" label="Annual payment value" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12} >
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional comments</Typography>
                        </Grid>
                        <RenderTextField name="financialIncetivesComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>

        </>
    );
}
